import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import Lottie from 'lottie-react';
import { useStateInRef } from 'seagull';
import { makeMockIntercomClient } from '~/intercom/intercomClient.mock';
import { actualReactStripeJs } from '~/stripe/reactStripeJs';
import { mockCookiesManager } from './CookiesManager';
function throwUnsetContextError(f) {
    return ()=>{
        throw new Error("Somebody is trying to use ".concat(f, " without a properly set context"));
    };
}
export const mockHotjar = {
    identify () {}
};
export const inertNewTabHandle = {
    close: ()=>{},
    isClosed: ()=>true
};
export const mockOpenNewTab = ()=>inertNewTabHandle;
export const MockReactPlayer = ()=>/*#__PURE__*/ _jsx(_Fragment, {});
export const MockYoutubePlayer = ()=>/*#__PURE__*/ _jsx(_Fragment, {});
export const MockGoogleButton = ()=>/*#__PURE__*/ _jsx(_Fragment, {});
export const MockLoomParser = async ()=>({
        type: 'video',
        html: '',
        title: '',
        provider_name: 'Loom',
        provider_url: '',
        thumbnail_height: 0,
        thumbnail_width: 0,
        thumbnail_url: '',
        duration: 0,
        height: null,
        width: null
    });
export class MockLocalStorage {
    clear() {
        this.storage = {};
    }
    getItem(key) {
        return key in this.storage ? this.storage[key] : null;
    }
    removeItem(key) {
        delete this.storage[key];
    }
    setItem(key, value) {
        this.storage[key] = value;
    }
    constructor(){
        _define_property(this, "storage", {});
    }
}
const Context = /*#__PURE__*/ createContext({
    getNow: throwUnsetContextError('getNow'),
    getTimezoneAbbreviation: throwUnsetContextError('getTimezoneAbbreviation'),
    usePlaidLink: throwUnsetContextError('usePlaidLink'),
    getHotjar: ()=>mockHotjar,
    personaClient: throwUnsetContextError('personaClient'),
    ReactPlayer: MockReactPlayer,
    YoutubePlayer: MockYoutubePlayer,
    Lottie: Lottie,
    GoogleButton: MockGoogleButton,
    loomParser: MockLoomParser,
    cookies: mockCookiesManager,
    logBIEventOld: ()=>{},
    logBIEvent: ()=>{},
    localStorage: new MockLocalStorage(),
    reactStripe: actualReactStripeJs,
    intercomClient: makeMockIntercomClient(),
    browser: {
        locationReload: throwUnsetContextError('locationReload'),
        changeLocation: ()=>{},
        getOrigin: ()=>'',
        copyToClipboard: throwUnsetContextError('copyToClipboard'),
        openNewTab: mockOpenNewTab,
        downloadCsv: ()=>{},
        injectScriptOrLink: async ()=>null,
        uploadFileToCloudStorage: async ()=>{},
        scrollIntoView: ()=>{}
    },
    nativeGoogleAuth: {
        signIn: throwUnsetContextError('nativeGoogleAuth.signIn')
    },
    isNativePlatform: ()=>false
});
export function IoContextProvider(props) {
    const getProps = useStateInRef(props);
    const value = useMemo(()=>{
        const _getProps = getProps(), { children: _ } = _getProps, rest = _object_without_properties(_getProps, [
            "children"
        ]);
        return rest;
    }, []);
    return /*#__PURE__*/ _jsx(Context.Provider, {
        value: value,
        children: props.children
    });
}
export const useIoContext = ()=>useContext(Context);
export default IoContextProvider;
